<template>
    <ul class="ButtonAnswers">
        <li v-for="item in answers" :key="item.id" class="ButtonAnswers__answer">
            <big-button
                :title="item.title"
                :icon="item.icon"
                :aria-described-by="ariaDescribedBy"
                @button-click="$emit('input' , [item.next, item.previous, item.id])">
            </big-button>
        </li>
    </ul>
</template>

<script>
    import BigButton from '../buttons/BigButton.vue';
    export default {
        components: {BigButton},

        props: {
            answers: {
                type: Object,
                required: true
            },
            ariaDescribedBy: {
                type: String,
                default: ''
            }
        }
    }

</script>

<style scoped lang="scss">
    .ButtonAnswers {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 0;
        list-style: none;

        @media screen and (min-width: 767px) {
            margin-top: 50px;
        }
    }

    .ButtonAnswers__answer {
        margin: 0 20px;

        @media screen and (min-width: 767px) {
            margin: 0 80px;
        }
    }
</style>
